<div class="error-content narrow">
  <div class="error-content-header">
    <svg-icon key="app-window-error-404" fontSize="56px"></svg-icon>
    <h3>Page not found</h3>
  </div>

  <button class="btn btn-primary" (click)="navigateToDefaultPage()">View homepage</button>
</div>
